
export default function Endorsement() {
  return (
    <section className="relative py-16 bg-[#0a1628]">
      <div className="max-w-5xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4" style={{ fontFamily: "'Roboto', sans-serif" }}>
            "WHY <span className="text-[#DC2626]">I HAVE THIS</span>."
          </h2>
        </div>

        {/* Endorsement Card */}
        <div className="bg-gradient-to-br from-[#0f1d2e] to-[#1a2332] border-2 border-[#DC2626]/30 rounded-2xl overflow-hidden shadow-2xl">
          <div className="flex flex-col md:flex-row">
            {/* Image Side */}
            <div className="md:w-2/5 relative">
              <div className="w-full h-96 md:h-full">
                <img 
                  src="https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/dadaf59f289a861c44051d9874a96e48.jpeg"
                  alt="Matt Theriault"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0f1d2e]/50"></div>
              </div>
              <div className="absolute bottom-6 left-6 bg-[#DC2626] px-4 py-2 rounded-lg">
                <p className="text-white font-black text-sm uppercase tracking-wider">Matt Theriault</p>
              </div>
            </div>

            {/* Quote Side */}
            <div className="md:w-3/5 p-8 md:p-12 flex flex-col justify-center">
              <div className="mb-6">
                <i className="ri-double-quotes-l text-6xl text-[#DC2626]/30"></i>
              </div>

              <blockquote className="text-2xl md:text-[26px] text-gray-200 leading-relaxed mb-8 italic">
                I don't recommend this because of the business model. I recommend it because of the <strong className="text-white not-italic">Leverage</strong>.
                <br /><br />
                I want to know that if someone messes with my family or my property, I can hit a button and <strong className="text-[#DC2626] not-italic">unleash the lawyers</strong>.
                <br /><br />
                It's the cheapest insurance policy against stupidity I've ever found.
              </blockquote>

              <div className="flex items-center gap-4 mb-6">
                <div className="h-1 w-16 bg-[#DC2626]"></div>
                <div>
                  <p className="text-white font-black text-lg">Matt Theriault</p>
                  <p className="text-gray-400 text-sm">Epic Real Estate Investing</p>
                </div>
              </div>

              {/* Skeptic Bridge Link */}
              <div className="mt-4">
                <a 
                  href="/about" 
                  className="inline-flex items-center gap-2 text-[#FFD700] hover:text-white text-base underline transition-colors duration-300 cursor-pointer"
                >
                  Read the full story of how I used this to recover $4,500 from a scam contractor here
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Indicators */}
        <div className="grid grid-cols-3 gap-6 mt-12">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 bg-[#DC2626]/20 rounded-full flex items-center justify-center">
              <i className="ri-shield-check-fill text-3xl text-[#DC2626]"></i>
            </div>
            <p className="text-sm text-gray-400 font-semibold">Trusted Protection</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 bg-[#DC2626]/20 rounded-full flex items-center justify-center">
              <i className="ri-team-fill text-3xl text-[#DC2626]"></i>
            </div>
            <p className="text-sm text-gray-400 font-semibold">Real Attorneys</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-3 bg-[#DC2626]/20 rounded-full flex items-center justify-center">
              <i className="ri-time-fill text-3xl text-[#DC2626]"></i>
            </div>
            <p className="text-sm text-gray-400 font-semibold">Instant Access</p>
          </div>
        </div>
      </div>
    </section>
  );
}
